import { render, staticRenderFns } from "./LoadingLogin.vue?vue&type=template&id=2773c20c&"
import script from "./LoadingLogin.vue?vue&type=script&langth=ts&lang=js&"
export * from "./LoadingLogin.vue?vue&type=script&langth=ts&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports